import React, {useState, useEffect} from 'react';
import axios from 'axios';
import validator from 'validator'
import moment from 'moment'
import { toast } from 'react-toastify';
import {useSelector} from 'react-redux'
import { selectUser } from 'src/stores/userSlice';
import SharedProfileForm from '../components/SharedProfileForm';

export const USProfile = ({ onUploadImage, profileData, isUploadingImg, refreshProfile }) => {
	const [profile, setProfile] = useState({})
		const [isDisabled, setIsDisabled] = useState(false)
	const [checked, setChecked] = useState(false);
	const [editable, setEditable] = useState(false)
	const [emailError, setEmailError] = useState('')
	const [timestamp, setTimestamp] = useState(Date.now())
	const user = useSelector(selectUser)
	const initialState= {
		fName:'',
		lName:'',
		fatherName:'',
		phone:'',
		bloodGrp:'',
		dob:'',
		originalDob:'',
		addrLine1:'',
		addrLine2:'',
		city:'',
		empstate:'',
		pincode:'',
		email:'',
		contactNo:'',
		ssn:'',
		passportNo:'',	
		expiryDt:'',
		accountNo:'',	
		manager:'',
		status:'',
		designation:'',
		doj: '',
		dataAcesMail: '',
		location: ''
	}
	const [state, setState] = useState(initialState)
	const [remote, setRemote] = useState('No')
	const [hasPassport, setHasPassport] = useState('No')

	const updateProfile = async  () => {
		if(profile?.ALLOW_EDIT==='No'){
			toast.error('Please reach out to manager to update details')
		}else {		
			if(state.fName && state.lName && state.fatherName && state.phone && state.bloodGrp && state.dob && state.email && state.contactNo && state.addrLine1 && state.addrLine2 && state.city && state.pincode && state.ssn && state.accountNo && hasPassport && remote){							
				if(checked===true){
					setIsDisabled(true)					
					try{
						await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateProfile`,{
							empcode:user?.emp_code,
							empName:state.fName+' '+state.lName,
							fatherName:state.fatherName,
							phone:state.phone,
							bloodGrp:state.bloodGrp,
							dob:state.dob,
							originalDob:state.originalDob,
							email:state.email,
							contactNo:state.contactNo,
							addrLine1:state.addrLine1,
							addrLine2:state.addrLine2,
							city:state.city,
							pincode: state.pincode,
							ssn:state.ssn,
							hasPassport,
							passportNo:state.passportNo,
							expiryDt:state.expiryDt,
							remote,
							accountNo:state.accountNo,
							lastUpdatedDt:moment(new Date()).format('YYYY-MM-DD'),
							isManager:user?.is_admin,
						})
						toast.success("Profile updated successfully")	
						setIsDisabled(false)
						if (refreshProfile) refreshProfile()
					}catch(error){				
						setIsDisabled(false)
						let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : 'Something went wrong. Please try again later'
						toast.error(errmsg)
					}	
				}else toast.error('Please select the checkbox')	 
			}
			else(toast.error('All fields are mandatory for the profile update'))
		}				
	}

	useEffect(()=>{
		if(profileData) {
			setTimestamp(Date.now())
			setProfile(profileData)
			setHasPassport(profileData?.HAS_PASSPORT)
			setRemote(profileData?.REMOTE_EMPLOYEE)
			setState({
				fName:(profileData?.EMP_NAME)?.split(' ')[0] || '',
				lName:(profileData?.EMP_NAME)?.substr(profileData?.EMP_NAME.indexOf(' ') + 1) || '',
				fatherName:profileData?.EMP_FATHERS_NAME || '',
				phone:profileData?.EMP_MOBILE_NO || '',
				bloodGrp:profileData?.EMP_BLOOD_GROUP || '',
				dob:profileData?.EMP_DATE_OF_BIRTH ? moment(profileData?.EMP_DATE_OF_BIRTH).format('YYYY-MM-DD') : '',
				originalDob:profileData?.ORIGINAL_DOB ? moment(profileData?.ORIGINAL_DOB).format('YYYY-MM-DD') : '',
				doj:profileData?.EMP_DATE_OF_JOIN ? moment(profileData?.EMP_DATE_OF_JOIN).format('YYYY-MM-DD') : '',
				addrLine1:profileData?.EMP_ADDRESS_1 || '',
				addrLine2:profileData?.EMP_ADDRESS_2 || '',
				city:profileData?.EMP_CITY || '',
				empstate:profileData?.EMP_STATE || '',
				pincode:profileData?.PINCODE || '',
				location:profileData?.EMP_LOCATION || '',
				dataAcesMail:profileData?.EMP_WORK_EMAIL || '',
				email:profileData?.EMP_PERSONAL_EMAIL || '',
				contactNo:profileData?.EMERGENCY_CONTACT_NO || '',
				ssn:profileData?.SSN || '',
				passportNo:profileData?.PASSPORT_NO || '',	
				expiryDt:profileData?.PASSPORT_EXPIRY_DT ? moment(profileData?.PASSPORT_EXPIRY_DT).format('YYYY-MM-DD') : '',
				accountNo:profileData?.EMP_ACCOUNT_NO || '',
				status:profileData?.EMP_STATUS || '',
				designation:profileData?.DESIGNATION || '',
				manager:profileData?.REPORTING_MANAGER_ID || '',				
			})		
			let editFlag = (profileData?.ALLOW_EDIT === 'No') ? true : false
			setEditable(editFlag)
			setChecked(editFlag)
		}
	},[profileData])

	const handleCheckBoxChange = (event) => {
		setChecked(event.target.checked);
	};

	function handleChange(evt) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value
        });
		if(evt.target.name === 'email'){
            if (validator.isEmail(value)) {            
                setEmailError('Valid')
            } else {
                setEmailError('Enter valid Email!')
            }
        } 
		if(evt.target.name === 'remote'){
          setRemote(evt.target.value)
        }
		if(evt.target.name === 'hasPassport'){
          setHasPassport(evt.target.value)
        }
    }

		
	
	return (
		<SharedProfileForm 
			isUS={true}
			state={{...state, hasPassport, remote}}
			handleChange={(evt) => {
				if (evt.target.name === 'hasPassport') setHasPassport(evt.target.value);
				else if (evt.target.name === 'remote') setRemote(evt.target.value);
				else handleChange(evt);
			}}
			handleCheckBoxChange={handleCheckBoxChange}
			checked={checked}
			updateProfile={updateProfile}
			editable={editable}
			emailError={emailError}
			isLoading={isDisabled}
			userSummary={{
				avatar: profile?.IMG_PATH ? `${process.env.REACT_APP_PUBLIC_URL}/${profile?.IMG_PATH}?t=${timestamp}` : null,
				name: state.fName + ' ' + state.lName,
				designation: state.designation,
				empId: profile?.EMP_CODE,
				location: profile?.EMP_LOCATION || '-',
				status: state.status,
				doj: state.doj ? moment(state.doj).format('DD MMM YYYY') : '-',
				manager: state.manager,
				workEmail: state.dataAcesMail
			}}
			onUploadImage={onUploadImage}
			isUploadingImg={isUploadingImg}
			isProfileView={true}
		/>
	)
}